import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "./ChartCard"
import { PALETTE, formatShort, NIVO_THEME } from "./palette"

const MonthlyChart = ({ data, currency }) => {
  const total = data.reduce((acc, d) => acc + d.value, 0)
  const subtitle = total > 0
    ? I18n.t("chantiers_dashboard.charts.total_invoiced", { amount: formatShort(total) })
    : null

  return (
    <ChartCard
      icon     = "chart-column"
      title    = {I18n.t("chantiers_dashboard.charts.monthly_invoiced")}
      subtitle = {subtitle}
      height   = {320}
      empty    = {total === 0 ? I18n.t("chantiers_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data         = {data}
        keys         = {["value"]}
        indexBy      = "label"
        margin       = {{ top: 18, right: 28, bottom: 54, left: 72 }}
        padding      = {0.32}
        colors       = {[PALETTE.indigo]}
        borderRadius = {3}
        enableLabel  = {false}
        axisBottom   = {{ tickRotation: -30, tickSize: 4, tickPadding: 6 }}
        axisLeft     = {{ tickValues: 5, format: (v) => formatShort(v) }}
        gridYValues  = {5}
        tooltip      = {({ value, indexValue }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "6px 10px", fontSize: 11, borderRadius: 6, boxShadow: "0 8px 20px rgba(15,23,42,0.25)" }}>
            <strong>{indexValue}</strong> · {formatShort(value)}
          </div>
        )}
        theme        = {NIVO_THEME}
      />
    </ChartCard>
  )
}

export default MonthlyChart
